/* FlightModels — Mystery Plane gift router  (test-mystery-plane theme)  v7
 * Router is the SOLE owner of the mystery-plane gift line. Kraken still shows its progress-bar UI and
 * still TRIGGERS the add (on threshold/render), but every Kraken gift-add (POST /cart/add.js?kraken=true
 * with the Rewards property) is INTERCEPTED so the correct single variant is what actually ends up in the
 * cart. Kraken's own variant therefore never lands -> no duplicate gift, ever.
 *   - cart has another line WITH a sku  -> US variant  51486701453618 (SKU -> FulfillPlus / Texas)
 *   - cart has no other sku'd line      -> China variant 51486558912818 (no SKU -> 14 Fifth Street / China)
 * Also: exactly one gift, qty 1; currency-safe below-threshold removal; re-syncs Kraken's drawer after edits.
 */
(function () {
  "use strict";
  var CHINA = 51486558912818;               // no SKU  -> China (addable)
  var US    = 51486701453618;               // SKU FM-SM-COM13-8-REG -> FulfillPlus / Texas
  var GIFTS = [CHINA, US];
  var DETECT_ONLY = [49790871404850];       // Kraken's configured default — always detected and swapped out
  var PROPS = { __krakenCartProduct: "Rewards", __krakenCartEvent: "CartRewards" };
  var THRESHOLD = 10000;                     // 100.00 in SHOP currency (USD) cents
  var BASE_CURRENCY = "USD";
  // Storefront exposes the presentment rate (presentment per 1 shop currency).
  // Divide the presentment total by it to compare against the USD threshold.
  function fxRate(){
    try {
      var r = window.Shopify && window.Shopify.currency && parseFloat(window.Shopify.currency.rate);
      return (r && isFinite(r) && r > 0) ? r : 1;
    } catch(e){ return 1; }
  }
  var PROTECTION = "ShippingProtection";
  var DEBUG = false;

  var STATE = window.__fmGift = { cart:null, installed:false, version:18, runs:0, intercepts:0, last:null };
  var origFetch = window.fetch.bind(window);
  function log(){ if (DEBUG && window.console) console.log.apply(console, ["[FM gift]"].concat([].slice.call(arguments))); }

  function isGiftItem(it){
    if (it.properties && it.properties.__krakenCartProduct === "Rewards") return true;
    if (GIFTS.indexOf(it.variant_id) !== -1) return true;
    if (DETECT_ONLY.indexOf(it.variant_id) !== -1) return true;
    return false;
  }
  function getCart(){ return origFetch("/cart.js", {headers:{Accept:"application/json"}}).then(function(r){return r.json();}); }
  function rawChange(key, qty){ return origFetch("/cart/change.js", {method:"POST", headers:{"Content-Type":"application/json",Accept:"application/json"}, body:JSON.stringify({id:key, quantity:qty})}).then(function(r){return r.json();}); }
  function rawAdd(id){ return origFetch("/cart/add.js", {method:"POST", headers:{"Content-Type":"application/json",Accept:"application/json"}, body:JSON.stringify({items:[{id:id, quantity:1, properties:PROPS}]})}).then(function(r){return r.json();}); }

  function analyze(cart){
    var gifts=[], merch=0, real=0, hasSku=false;
    cart.items.forEach(function(it){
      if (isGiftItem(it)) { gifts.push(it); return; }
      if (it.properties && it.properties.__krakenCartProduct === PROTECTION) return;
      merch += (it.final_line_price != null ? it.final_line_price : it.line_price); real++;
      if (it.sku && String(it.sku).trim() !== "") hasSku = true;
    });
    var below = (real === 0) || ((merch / fxRate()) < THRESHOLD);   // currency-safe
    return { gifts:gifts, want: hasSku ? US : CHINA, below:below, hasSku:hasSku, currency:cart.currency, merch:merch };
  }

  // Make the cart hold exactly ONE gift of `want` (qty 1), or NONE if remove. Resolves to whether it changed anything.
  function enforce(cart, want, remove){
    var gifts = cart.items.filter(isGiftItem);
    var chain = Promise.resolve(), changed = false;
    if (remove){
      gifts.forEach(function(g){ changed = true; chain = chain.then(function(){ log("remove (below-threshold)", g.variant_id); return rawChange(g.key, 0); }); });
      return chain.then(function(){ return changed; });
    }
    var correct = gifts.filter(function(g){ return g.variant_id === want; });
    var wrong   = gifts.filter(function(g){ return g.variant_id !== want; });
    wrong.forEach(function(g){ changed = true; chain = chain.then(function(){ log("remove wrong", g.variant_id); return rawChange(g.key, 0); }); });
    if (correct.length === 0){ changed = true; chain = chain.then(function(){ log("add", want); return rawAdd(want); }); }
    else { correct.forEach(function(g, i){ if (i===0){ if (g.quantity !== 1){ changed = true; chain = chain.then(function(){ return rawChange(g.key, 1); }); } } else { changed = true; chain = chain.then(function(){ return rawChange(g.key, 0); }); } }); }
    return chain.then(function(){ return changed; });
  }

  // serialize all gift mutations (intercept + reconcile) so they never interleave
  var lock = Promise.resolve();
  function withLock(fn){ var p = lock.then(fn, fn); lock = p.then(function(){}, function(){}); return p; }

  var syncing = false;
  function syncDrawer(){
    if (syncing) return; syncing = true;
    try { if (window.KrakenCart && typeof window.KrakenCart.updateCart === "function") window.KrakenCart.updateCart(); } catch(e){}
    setTimeout(function(){ syncing = false; }, 120);
  }

  function reconcile(){
    return withLock(function(){
      return getCart().then(function(cart){
        STATE.runs++;
        var a = analyze(cart);
        STATE.cart = cart;
        STATE.last = { want:a.want, below:a.below, currency:a.currency, giftVariants:a.gifts.map(function(g){return g.variant_id;}), at:Date.now() };
        if (a.gifts.length === 0) return false;             // no gift present; Kraken triggers adds via the intercept
        return enforce(cart, a.want, a.below);
      });
    }).then(function(changed){ if (changed) syncDrawer(); })
      .catch(function(e){ if (window.console) console.warn("[FM gift] recon err", e); });
  }

  function isKrakenGiftAdd(url, init){
    if (!/\/cart\/add(\.js)?/.test(url)) return false;
    if (url.indexOf("kraken=true") === -1) return false;    // Kraken tags its own adds with ?kraken=true
    var body = (init && init.body) || "";
    if (typeof body !== "string") return false;
    if (body.indexOf('"' + PROTECTION + '"') !== -1) return false;  // let Kraken's shipping-protection add pass through
    return body.indexOf('"Rewards"') !== -1 || GIFTS.some(function(id){ return body.indexOf(String(id)) !== -1; });
  }

  // reconcile shortly after an event, then again a bit later — some Kraken edits (qty stepper to 0) settle
  // server-side AFTER their drawer render, so a single reconcile can read a stale cart.
  var t; function schedule(fast){ clearTimeout(t); t = setTimeout(function(){ reconcile(); setTimeout(reconcile, 600); }, fast ? 0 : 150); }
  // if the last known state was already below threshold, react with no debounce at all
  function scheduleSmart(){ schedule(!!(STATE.last && STATE.last.below)); }
  var RE = /\/cart\/(add|change|update|clear)/;

  window.fetch = function(input, init){
    var url = typeof input === "string" ? input : (input && input.url) || "";
    if (isKrakenGiftAdd(url, init)){
      STATE.intercepts++;
      var body = (init && init.body) || "";
      // (a) zero round trips: Kraken fires its gift-add more than once. If we already
      // settled the correct single gift moments ago, answer straight from cache.
      var fresh = STATE.last && (Date.now() - STATE.last.at) < 2000;
      if (fresh && !STATE.last.below && STATE.last.giftVariants.length === 1
          && STATE.last.giftVariants[0] === STATE.last.want && STATE.cart) {
        return Promise.resolve(new Response(JSON.stringify(STATE.cart), { status:200, headers:{"Content-Type":"application/json"} }));
      }
      // (b) ONE round trip: we already know which variant we want (reconcile keeps it current,
      // and a gift-add can never change it — `want` depends only on non-gift SKU'd lines).
      // Rewrite the variant id in Kraken's own request and let it fly, instead of
      // getCart -> add -> getCart.
      if (fresh && !STATE.last.below && STATE.last.giftVariants.length === 0){
        var want = STATE.last.want, patched = body;
        GIFTS.concat(DETECT_ONLY).forEach(function(id){
          patched = patched.split(String(id)).join(String(want));
        });
        if (patched !== body || body.indexOf(String(want)) !== -1){
          var ninit = {}; for (var k in init) ninit[k] = init[k];
          ninit.body = patched;
          return origFetch(input, ninit).then(function(res){
            schedule();                       // verify in the background
            return res;
          });
        }
      }
      return withLock(function(){
        return getCart().then(function(cart){
          var a = analyze(cart);
          return enforce(cart, a.want, a.below).then(function(changed){
            return changed ? getCart() : cart;      // only re-read when we actually mutated
          });
        });
      }).then(function(finalCart){
        STATE.cart = finalCart;
        var fa = analyze(finalCart);
        STATE.last = { want:fa.want, below:fa.below, currency:fa.currency, giftVariants:fa.gifts.map(function(g){return g.variant_id;}), at:Date.now() };
        return new Response(JSON.stringify(finalCart), { status:200, headers:{"Content-Type":"application/json"} });
      }).catch(function(e){
        if (window.console) console.warn("[FM gift] intercept err", e);
        return origFetch(input, init);
      });
    }
    var pr = origFetch(input, init);
    if (RE.test(url)) {
      // /cart/change.js and friends return the FULL cart, so we can act on that response
      // instead of spending another round trip re-fetching it.
      // ONLY the below-threshold REMOVAL is handled here: removing is idempotent, so a
      // double-fire is harmless. Adding is NOT idempotent - two concurrent handlers would
      // each see "no gift" and each add one (that produced qty 2) - so adds stay on the
      // normal serialized reconcile path.
      pr.then(function(res){
        var clone;
        try { clone = res.clone(); } catch(e){ scheduleSmart(); return; }
        clone.json().then(function(cart){
          if (!cart || !cart.items) { scheduleSmart(); return; }
          var a = analyze(cart);
          STATE.cart = cart;
          STATE.last = { want:a.want, below:a.below, currency:a.currency,
                         giftVariants:a.gifts.map(function(g){return g.variant_id;}), at:Date.now() };
          if (a.below && a.gifts.length > 0){
            withLock(function(){ return enforce(cart, a.want, true); })
              .then(function(changed){ if (changed) syncDrawer(); })
              .catch(function(){})
              .then(function(){ schedule(true); });
          } else {
            scheduleSmart();
          }
        }).catch(function(){ scheduleSmart(); });
      }).catch(function(){});
    }
    return pr;
  };
  var oOpen = XMLHttpRequest.prototype.open, oSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function(m, u){ this.__u = u; return oOpen.apply(this, arguments); };
  XMLHttpRequest.prototype.send = function(){ if (this.__u && RE.test(this.__u)) this.addEventListener("loadend", function(){ schedule(); }); return oSend.apply(this, arguments); };

  document.addEventListener("DOMContentLoaded", schedule);
  window.addEventListener("pageshow", schedule);
  document.addEventListener("visibilitychange", function(){ if (!document.hidden) schedule(); });

  // Kraken edits the cart internally for drawer remove/qty changes WITHOUT a window.fetch/XHR we can hook,
  // but it re-renders its drawer (a Shadow DOM) afterward. Observe that shadow root and reconcile on any render.
  var observerAttached = false;
  function attachDrawerObserver(){
    if (observerAttached) return;
    var host = document.querySelector("#kraken-cart-drawer-container");
    var root = host && host.shadowRoot;
    if (!root) return;
    try {
      new MutationObserver(function(){ schedule(); }).observe(root, { childList:true, subtree:true, characterData:true });
      observerAttached = true;
      log("drawer observer attached");
    } catch(e){}
  }
  var oi = setInterval(function(){ attachDrawerObserver(); if (observerAttached) clearInterval(oi); }, 500);

  // Backstop: guarantees eventual correctness even if some cart edit surfaces no event we hooked
  // (idempotent — does a single /cart.js read and only acts if the gift is wrong). Visible tab only.


  // ---- cart icon race ------------------------------------------------------
  // The cart icon is a plain <a href="/cart">. Kraken hijacks it with JS, but this
  // script runs BEFORE Kraken's (both defer, we're earlier in document order), so a
  // fast click lands before Kraken binds and the browser follows the link to the
  // full /cart page. Hold the click until Kraken is ready, then open the drawer.
  // Fails OPEN: if Kraken never shows up within 2.5s, let /cart load as before.
  function isCartIcon(el){
    if (!el || !el.closest) return false;
    var a = el.closest('a[href="/cart"], a[href^="/cart?"], #cart-icon-bubble');
    return !!a;
  }
  document.addEventListener("click", function(e){
    if (e.defaultPrevented || e.button) return;
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;   // let new-tab clicks through
    var path = e.composedPath ? e.composedPath() : [e.target];
    var hit = null;
    for (var i = 0; i < path.length; i++){ if (isCartIcon(path[i])) { hit = path[i]; break; } }
    if (!hit) return;
    if (window.KrakenCart && typeof window.KrakenCart.toggleCart === "function") return;  // Kraken ready, leave it alone
    e.preventDefault(); e.stopImmediatePropagation();
    var waited = 0;
    (function wait(){
      if (window.KrakenCart && typeof window.KrakenCart.toggleCart === "function"){
        try { window.KrakenCart.toggleCart(); } catch(err){ window.location.href = "/cart"; }
        return;
      }
      waited += 100;
      if (waited >= 2500) { window.location.href = "/cart"; return; }
      setTimeout(wait, 100);
    })();
  }, true);

  // ---- checkout guard -------------------------------------------------------
  // The gift is removed asynchronously, so there is a ~1s window after a cart edit
  // where a below-threshold cart still holds the gift. Gate the checkout action:
  // run a reconcile first, then proceed. Fails OPEN on any error or after 1500ms
  // so a bug here can never stop someone checking out.
  var GUARD_MS = 1500;
  var guardPassed = false;
  function looksLikeCheckout(el){
    if (!el || !el.closest) return false;
    var n = el.closest("button,a,input");
    if (!n) return false;
    if (n.name === "checkout" || n.getAttribute("name") === "checkout") return true;
    var href = n.getAttribute && n.getAttribute("href");
    if (href && href.indexOf("/checkout") === 0) return true;
    return /checkout/i.test((n.textContent || "") + " " + (n.getAttribute("aria-label") || ""));
  }
  function onCheckoutClick(e){
    if (guardPassed) { guardPassed = false; return; }
    var path = e.composedPath ? e.composedPath() : [e.target];
    var hit = null;
    for (var i = 0; i < path.length; i++){ if (looksLikeCheckout(path[i])) { hit = path[i]; break; } }
    if (!hit) return;
    // Fast path: if we verified the cart moments ago and it is already correct,
    // there is nothing to clean up - let the click through untouched.
    var fresh = STATE.last && (Date.now() - STATE.last.at) < 2500;
    var clean = fresh && (STATE.last.below
                  ? STATE.last.giftVariants.length === 0
                  : (STATE.last.giftVariants.length === 1 && STATE.last.giftVariants[0] === STATE.last.want));
    if (clean) return;
    e.preventDefault(); e.stopImmediatePropagation();
    var done = false;
    function go(){
      if (done) return; done = true;
      guardPassed = true;
      // Do NOT re-click: Kraken re-renders its drawer during reconcile, so the
      // original button is usually detached by now and the click would vanish.
      window.location.href = "/checkout";
    }
    setTimeout(go, GUARD_MS);                 // fail-open backstop
    try { reconcile().then(go).catch(go); } catch(err){ go(); }
  }
  document.addEventListener("click", onCheckoutClick, true);
  function guardShadow(){
    var h = document.querySelector("#kraken-cart-drawer-container");
    if (h && h.shadowRoot && !h.shadowRoot.__fmGuarded){
      h.shadowRoot.__fmGuarded = true;
      h.shadowRoot.addEventListener("click", onCheckoutClick, true);
    }
  }
  setInterval(guardShadow, 1000); guardShadow();

  // Backstop poll. reconcile() is a no-op while the cart holds no gift line (gift adds always come
  // through the hooked fetch above), so with no gift present only re-read every 10s; with a gift
  // present keep the original 1.5s cadence.
  setInterval(function(){
    if (document.hidden) return;
    var l = STATE.last;
    if (l && l.giftVariants.length === 0 && (Date.now() - l.at) < 10000) return;
    reconcile();
  }, 1500);

  schedule();
  STATE.installed = true;
  log("router v18 installed  US=" + US + " CHINA=" + CHINA);
})();
